export default __webpack_public_path__ + "static/piercing-b2c64214684be278f71e588e9dd7ef75.png";